import { render, staticRenderFns } from "./MarketingMessage.vue?vue&type=template&id=743bf96a&"
import script from "./MarketingMessage.vue?vue&type=script&lang=js&"
export * from "./MarketingMessage.vue?vue&type=script&lang=js&"
import style0 from "./MarketingMessage.vue?vue&type=style&index=0&id=743bf96a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports